import React from "react";

const Article = ({ image, children }) => {
  return (
    <div className="article">
      <div
        className="flex align-center mb-20 image-wrapper"
        style={{ backgroundImage: `url(${image})` }}
      />
      {children}
    </div>
  );
};

export default Article;
